import * as money from 'shop/assets/js/utils/money';

export default class ProductVariant {
    constructor(data) {
        this.data = data;
        this.code = data.code;
        this.enabled = data.enabled;
        this.sellable = data.sellable;
        this.price = data.channel_pricings.fronda_web.price;
        this.originalPrice = data.channel_pricings.fronda_web.original_price;
        this.optionValues = data.option_values;
        this.tracked = data.tracked;
        this.onHand = data.on_hand;
        this.onHold = data.on_hold;
        this.extraShippingCosts = data.extra_shipping_cost;
        this.collectionRequired = data.collection_required;
        this.hasFreeShipping = data.has_free_shipping;
        this.optionValueText = data.option_value_text;
        this.minimumOrderQuantity = data.minimum_order_quantity;
    }

    get hasDiscount() {
        return this.originalPrice > this.price;
    }

    get discountPercent() {
        const discount = ((this.originalPrice - this.price) / this.originalPrice) * 100;
        return Math.floor(discount);
    }

    get priceFormatted() {
        return money.format(this.price);
    }

    get originalPriceFormatted() {
        return money.format(this.originalPrice);
    }

    get stock() {
        return Number(this.onHand - this.onHold);
    }

    get hasExtraShippingCosts() {
        return this.extraShippingCosts > 0;
    }

    get extraShippingCostsFormatted() {
        return money.format(this.extraShippingCosts);
    }

    get isTracked() {
        return this.tracked;
    }

    get isSellable() {
        return this.sellable;
    }

    get hasLowStock() {
        return this.data.has_low_stock;
    }

    numberAsPrice(number) {
        return money.format(number);
    }
}
